export const translations = {
  en: {
    seo: {
      title: 'The Lash Room | Elevated Lash & Brow Beauty in West Island',
      description:
        'Custom lash extensions, lash lifts, and brow lamination in a cozy, elevated studio in Sainte-Geneviève, West Island, Montreal.',
    },
    languageLabel: 'Language',
    nav: {
      services: 'Services',
      about: 'About',
      reviews: 'Reviews',
      location: 'Location',
      faq: 'FAQ',
      bookNow: 'Book Now',
      bookAppointment: 'Book Appointment',
      instagram: 'Instagram',
    },
    hero: {
      locationPill: 'Sainte-Geneviève, Montreal',
      title: 'Elevated Lash & Brow Beauty in West Island',
      subtitle:
        'Custom lash extensions, lash lifts, and brow lamination in a cozy, elevated studio in Sainte-Geneviève.',
      viewServices: 'View Services',
      imageAlt: 'Beautiful natural lash extensions',
    },
    highlights: {
      items: [
        'Personalized lash sets',
        'Cozy private studio',
        'West Island location',
        'Easy online booking',
      ],
    },
    services: {
      title: 'Our Services',
      subtitle: 'Enhance your natural beauty with our specialized lash and brow treatments.',
      bookNow: 'Book Now',
      additionalTitle: 'Additional Services',
      cards: [
        {
          title: 'Lash Lift & Tint',
          description:
            'A semi-permanent treatment that lifts, curls, and darkens your natural lashes for a fuller, effortless look.',
          price: '100',
          duration: '1 hour',
        },
        {
          title: 'Classic Extensions',
          description: 'The most natural-looking set, perfect for everyday elegance. Applied 1:1 on your natural lashes.',
          note: 'Price varies • 1hr+',
        },
        {
          title: 'Hybrid Extensions',
          description:
            'A mix between classic and volume; fuller than classic but softer than volume for a textured look.',
          note: 'Price varies • 1.5hr+',
        },
        {
          title: 'Volume Extensions',
          description:
            'A fuller, more dramatic look for maximum impact. Handmade fans applied to each natural lash.',
          note: 'Price varies • 2hr+',
        },
        {
          title: 'YY Lashes',
          description:
            "Lightweight lashes shaped like a 'Y' that create a textured, soft enhanced appearance.",
          note: 'Price varies • 1.5hr+',
        },
        {
          title: 'Brow Lamination',
          description:
            'A treatment that enhances your natural brows, giving them a fuller, more defined, and set look.',
          price: '100',
          duration: '1 hour',
        },
      ],
      additional: {
        removal: 'Removal',
        patchTest: 'Patch Test',
        homeService: 'Home Service',
        travelFee: 'Travel fee',
        startingAt: 'Starting at $50',
        free: 'Free',
        min30: '30 min',
        min20: '20 min',
      },
    },
    about: {
      title: 'The Lash Room Experience',
      body:
        'At The Lash Room, every appointment is designed to feel like a personalized beauty experience — not just a service. We focus on enhancing your natural beauty in a calm, cozy, and elevated environment.',
      imageAlt: 'Calm beauty studio environment',
      points: [
        'Customized to your eye shape',
        'Meticulous attention to detail',
        'Relaxing, spa-like atmosphere',
        'Styles ranging from natural to dramatic',
      ],
    },
    gallery: {
      title: 'Our Work',
      subtitle: 'Follow us on Instagram for more results.',
      handle: '@thelashroom',
      imageAlt: 'The Lash Room Gallery',
    },
    reviews: {
      title: 'Loved by our clients',
      subtitle: 'Real words from real clients — consistent results, comfort, and retention.',
      cta: 'See reviews on Google',
      starsLabel: '5 star rating',
    },
    location: {
      title: 'Location & Hours',
      addressLabel: 'Address',
      phoneLabel: 'Phone',
      hoursLabel: 'Hours',
      openAddressLabel: 'Open address in Google Maps',
      openMapLabel: 'Open map in Google Maps',
      byAppointmentOnly: 'By appointment only',
      days: {
        wedThu: 'Wed - Thu',
        fri: 'Friday',
        sat: 'Saturday',
        sunTue: 'Sun - Tue',
        closed: 'Closed',
      },
    },
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Everything you need to know before your appointment.',
      items: [
        {
          q: 'How long do lash extensions last?',
          a: 'With proper care, lash extensions can last 4-6 weeks. However, since your natural lashes shed daily, we recommend a fill every 2-3 weeks to keep your set looking full and beautiful.',
        },
        {
          q: 'How often should I book fills?',
          a: 'To maintain optimal fullness, we recommend booking a fill appointment every 2 to 3 weeks. You must have at least 40% of your extensions remaining to be considered a fill.',
        },
        {
          q: 'Can I wear mascara with extensions?',
          a: 'We strongly advise against wearing mascara with lash extensions. Mascara breaks down the adhesive, causing premature shedding, and makes it very difficult to properly clean your lashes during fills.',
        },
        {
          q: 'How long does a lash lift last?',
          a: "A lash lift typically lasts 6-8 weeks, depending on your natural lash growth cycle. It's a fantastic low-maintenance alternative to extensions.",
        },
        {
          q: 'How should I prepare for my appointment?',
          a: "Please arrive with clean, makeup-free eyes and avoid caffeine right before your appointment to minimize eye twitching. Do not curl your lashes or wear waterproof mascara the day before.",
        },
      ],
    },
    finalCta: {
      title: 'Ready to book your next lash appointment?',
      body: 'Book online in minutes and enjoy a personalized beauty experience in our relaxing West Island studio.',
      button: 'Book Appointment',
    },
    footer: {
      blurb: 'Elevated lash extensions, lifts, and brow lamination in Sainte-Geneviève, Montreal.',
      quickLinks: 'Quick Links',
      servicesPricing: 'Services & Pricing',
      aboutStudio: 'About the Studio',
      locationHours: 'Location & Hours',
      faqPrep: 'FAQ & Prep',
      contact: 'Contact',
      rights: 'All rights reserved.',
      designed: 'Designed for beauty.',
    },
  },
  fr: {
    seo: {
      title: 'The Lash Room | Beauté cils & sourcils dans l’Ouest-de-l’Île',
      description:
        'Extensions de cils, rehaussement de cils et lamination des sourcils dans un studio chaleureux et raffiné à Sainte-Geneviève, dans l’Ouest-de-l’Île.',
    },
    languageLabel: 'Langue',
    nav: {
      services: 'Services',
      about: 'À propos',
      reviews: 'Avis',
      location: 'Emplacement',
      faq: 'FAQ',
      bookNow: 'Réserver',
      bookAppointment: 'Prendre rendez-vous',
      instagram: 'Instagram',
    },
    hero: {
      locationPill: 'Sainte-Geneviève, Montréal',
      title: 'Beauté cils & sourcils haut de gamme dans l’Ouest-de-l’Île',
      subtitle:
        'Extensions de cils, rehaussement de cils et lamination des sourcils dans un studio chaleureux et raffiné à Sainte-Geneviève.',
      viewServices: 'Voir les services',
      imageAlt: 'Extensions de cils naturelles et élégantes',
    },
    highlights: {
      items: [
        'Cils personnalisés',
        'Studio privé et chaleureux',
        'Ouest-de-l’Île',
        'Réservation en ligne',
      ],
    },
    services: {
      title: 'Nos services',
      subtitle: 'Sublimez votre beauté naturelle avec nos soins spécialisés pour les cils et les sourcils.',
      bookNow: 'Réserver',
      additionalTitle: 'Services additionnels',
      cards: [
        {
          title: 'Rehaussement de cils & teinture',
          description:
            'Un soin semi-permanent qui rehausse, recourbe et teinte vos cils naturels pour un regard plus fourni et sans effort.',
          price: '100',
          duration: '1 h',
        },
        {
          title: 'Extensions classiques',
          description:
            'Le look le plus naturel, parfait au quotidien. Application 1:1 sur vos cils naturels.',
          note: 'Prix variable • 1 h+',
        },
        {
          title: 'Extensions hybrides',
          description:
            'Un mélange entre classique et volume; plus fourni que le classique, plus léger que le volume pour un effet texturé.',
          note: 'Prix variable • 1,5 h+',
        },
        {
          title: 'Extensions volume',
          description:
            'Un look plus dense et spectaculaire. Des bouquets faits à la main appliqués sur chaque cil naturel.',
          note: 'Prix variable • 2 h+',
        },
        {
          title: 'Cils YY',
          description:
            "Des cils légers en forme de « Y » pour un effet doux, texturé et rehaussé.",
          note: 'Prix variable • 1,5 h+',
        },
        {
          title: 'Lamination des sourcils',
          description:
            'Un soin qui discipline et rehausse vos sourcils pour un look plus fourni, défini et structuré.',
          price: '100',
          duration: '1 h',
        },
      ],
      additional: {
        removal: 'Retrait',
        patchTest: 'Test cutané',
        homeService: 'Service à domicile',
        travelFee: 'Frais de déplacement',
        startingAt: 'À partir de 50 $',
        free: 'Gratuit',
        min30: '30 min',
        min20: '20 min',
      },
    },
    about: {
      title: 'L’expérience The Lash Room',
      body:
        'À The Lash Room, chaque rendez-vous est pensé comme une expérience beauté personnalisée — pas seulement un service. Nous mettons l’accent sur votre beauté naturelle dans une ambiance calme, chaleureuse et raffinée.',
      imageAlt: 'Ambiance de studio beauté calme et apaisante',
      points: [
        'Adapté à la forme de vos yeux',
        'Souci du détail',
        'Ambiance relaxante, style spa',
        'Styles du naturel au plus intense',
      ],
    },
    gallery: {
      title: 'Nos réalisations',
      subtitle: 'Suivez-nous sur Instagram pour voir plus de résultats.',
      handle: '@thelashroom',
      imageAlt: 'Galerie The Lash Room',
    },
    reviews: {
      title: 'Nos clientes adorent',
      subtitle: 'Des mots authentiques — résultats constants, confort et excellente tenue.',
      cta: 'Voir les avis sur Google',
      starsLabel: 'Note de 5 étoiles',
    },
    location: {
      title: 'Emplacement & horaires',
      addressLabel: 'Adresse',
      phoneLabel: 'Téléphone',
      hoursLabel: 'Heures',
      openAddressLabel: 'Ouvrir l’adresse dans Google Maps',
      openMapLabel: 'Ouvrir la carte dans Google Maps',
      byAppointmentOnly: 'Sur rendez-vous seulement',
      days: {
        wedThu: 'Mer - Jeu',
        fri: 'Vendredi',
        sat: 'Samedi',
        sunTue: 'Dim - Mar',
        closed: 'Fermé',
      },
    },
    faq: {
      title: 'Questions fréquentes',
      subtitle: 'Tout ce qu’il faut savoir avant votre rendez-vous.',
      items: [
        {
          q: 'Combien de temps durent les extensions de cils?',
          a: 'Avec un bon entretien, les extensions peuvent durer 4 à 6 semaines. Comme vos cils naturels tombent quotidiennement, nous recommandons une retouche toutes les 2 à 3 semaines pour garder un résultat bien fourni.',
        },
        {
          q: 'À quelle fréquence réserver une retouche?',
          a: 'Pour maintenir une belle densité, nous recommandons une retouche toutes les 2 à 3 semaines. Vous devez avoir au moins 40 % de vos extensions pour que ce soit considéré comme une retouche.',
        },
        {
          q: 'Puis-je porter du mascara avec des extensions?',
          a: 'Nous déconseillons fortement le mascara avec des extensions. Il fragilise la colle, provoque une chute prématurée et complique le nettoyage lors des retouches.',
        },
        {
          q: 'Combien de temps dure un rehaussement de cils?',
          a: 'Un rehaussement dure généralement 6 à 8 semaines, selon votre cycle de croissance. C’est une excellente option faible entretien.',
        },
        {
          q: 'Comment me préparer à mon rendez-vous?',
          a: 'Arrivez avec les yeux propres, sans maquillage, et évitez la caféine juste avant pour réduire les petits tremblements. Ne recourbez pas vos cils et n’utilisez pas de mascara waterproof la veille.',
        },
      ],
    },
    finalCta: {
      title: 'Prête à réserver votre prochain rendez-vous?',
      body: 'Réservez en ligne en quelques minutes et profitez d’une expérience beauté personnalisée dans notre studio relaxant de l’Ouest-de-l’Île.',
      button: 'Prendre rendez-vous',
    },
    footer: {
      blurb: 'Extensions de cils, rehaussement et lamination des sourcils à Sainte-Geneviève, Montréal.',
      quickLinks: 'Liens rapides',
      servicesPricing: 'Services & tarifs',
      aboutStudio: 'À propos du studio',
      locationHours: 'Emplacement & horaires',
      faqPrep: 'FAQ & préparation',
      contact: 'Contact',
      rights: 'Tous droits réservés.',
      designed: 'Conçu pour la beauté.',
    },
  },
};
